module.exports = __webpack_public_path__ + "static/Business_type_categories_Bantu_Market-0d8fb935f312dcc6a7c7a6ce19726758.png";